module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921081151_T.5bb4c0d1.jpg";